export default "__VITE_ASSET__Ogv4Ge4V__ 400w, __VITE_ASSET__BnorL8ZF__ 800w, __VITE_ASSET__DvXpUrSQ__ 1024w";